import React from 'react';
import type {
  Candidate,
  CandidateLegalTechSkill,
  GroupedExperiences,
  Taxonomy,
  User,
} from '@axiom/validation';
import { isSalesUser } from '@axiom/utils';

import { AnonymousBioProfileStatusUtil } from '../../../utils/anonymous-bio-profile-status-util';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { Banner } from '../../element/Banner/Banner';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Flashy } from '../../element/Flashy/Flashy';

import { BioViewCandidate } from './BioViewCandidate';

export type BioViewProps = {
  candidate: Candidate;
  groupedExperiences: GroupedExperiences[];
  legalTechSkills: CandidateLegalTechSkill[];
  taxonomy: Taxonomy;
  user?: User;
  onNavigate?: (hideHighlights?: boolean, hideLocation?: boolean) => void;
  isAnonymous?: boolean;
};

export const BioView = ({
  candidate,
  groupedExperiences,
  legalTechSkills,
  taxonomy,
  user,
  onNavigate,
  isAnonymous = false,
}: BioViewProps) => {
  const showDownload =
    !isSalesUser(user) ||
    isAnonymous ||
    (isSalesUser(user) &&
      !AnonymousBioProfileStatusUtil.statusSet().has(candidate.profileStatus) &&
      candidate.isProfileShared);
  return (
    <Gutter vertical="24px" name="BIO_VIEW">
      <Banner type="critical" impact="low" name="SHARE_BIO_BANNER">
        <ParagraphHeader as="span">
          <Flashy color="textDefault">Sharing this bio with a client?</Flashy>
        </ParagraphHeader>{' '}
        {showDownload ? (
          <span data-test="BANNER_DOWNLOAD_TEXT">
            Click the download button below.
          </span>
        ) : (
          ''
        )}{' '}
        Clients can’t open bio links.
      </Banner>
      <Gutter bottom="24px" />
      <Flashy backgroundColor="panelLight">
        <BioViewCandidate
          candidate={candidate}
          groupedExperiences={groupedExperiences}
          legalTechSkills={legalTechSkills}
          taxonomy={taxonomy}
          user={user}
          onNavigate={onNavigate}
          isAnonymous={isAnonymous}
        />
      </Flashy>
    </Gutter>
  );
};
